import {
  InitClient,
  GetByParas,
  Post,
  PostWithParas,
} from "../ZeusAPIClient.js";
import { apiConfig } from "../../config.js";
import { Decrypt, Encrypt } from "../Logic/CryptoLogic";
import { Predicate } from "../Model/Predicate.js";
import { PagingBody } from "../Model/PagingBody";
InitClient(apiConfig.clientId, apiConfig.clientSecret, apiConfig.host);
//var userinfo= JSON.parse(Decrypt(window.sessionStorage.getItem('userinfo')));

//获取当前用户所有系统角色
async function GetCurrentUserRoles(userid) {
  var currentUserRoles = window.sessionStorage.getItem("CurrentUserRoles");
  if (!currentUserRoles) {
    var paras = {
      appId: apiConfig.appid,
      userId: userid,
    };
    currentUserRoles = await GetByParas(
      "c258d849-6866-4399-a544-04e61f84e28e",
      paras
    );
    window.sessionStorage.setItem(
      "CurrentUserRoles",
      Encrypt(JSON.stringify(currentUserRoles))
    );
    return currentUserRoles;
  } else {
    return JSON.parse(Decrypt(currentUserRoles));
  }
}
//获取当前用户的当前角色
async function GetCurrentUserRole(userid) {
    var currentUserRole = window.sessionStorage.getItem("CurrentUserRole");
    if(!currentUserRole)
    {
        var roles=GetCurrentUserRoles();
        currentUserRole=roles[0];
        window.sessionStorage.setItem(
            "CurrentUserRole",
            Encrypt(JSON.stringify(currentUserRole))
          );
        return currentUserRole;
    }
    else
    {
        return JSON.parse(Decrypt(currentUserRole));
    }
}
async function GetSystemPowers(roleId) {
  var paras = {
    appid: apiConfig.appid,
    roleid: roleId,
  };
  return await GetByParas("2c8b33bd-29e8-4406-8440-85963fc174bd", paras);
}
 function GetCurrentUserInfo() {
  var userinfo = JSON.parse(Decrypt(window.sessionStorage.getItem("userinfo")));
  return userinfo;
}

async function GetNewGuid() {
  var id = await GetByParas("6750fabf-6168-4e9c-b9f8-5acaaa23561b", "");
  return id;
}
//获取Guid
async function GetGuid() {
  var paras = {};
  return await GetByParas("6750fabf-6168-4e9c-b9f8-5acaaa23561b", paras);
}
//获取未读待办事项
function GetNoRead(userId) {
  var data = {
    userId: userId,
  };
  return GetByParas("291f34ba-ea50-4e4a-9cd1-c5e06065817c", data);
}
//获取未读待办事项列表
function GetDoneMessageList(predicates, pageIndex, pageSize, orderBy, sort) {
  var pb = new PagingBody(predicates, pageIndex, pageSize, orderBy, sort);
  return Post("6b72154e-2c27-4680-b4a6-680d94eff27b", pb);
}
//将待办事项未读设为已读
function SetDoneMessageRead(id) {
  var data = {
    id: id,
  };
  return GetByParas("d86866d2-df59-4053-9da5-be42c5d687e2", data);
}

async function GetChildrenFrameIdsByParentID(parentId) {
  var frames = await GetByParas("d6da2a91-21b8-4552-843e-a953293495f1", {
    id: parentId,
  });
  return frames.join(",");
}
async function GetChildrenFrameIdsByParentIDLevelOne(parentId) {
  var frameIds = [];
  var predicates = [];
  predicates.push(new Predicate("IsDelete", 0, "eq", 1));
  predicates.push(new Predicate("ParentId", parentId, "eq", 1));
  var frames = await Post("ee823424-8940-4305-bb32-428af243fbc4", predicates);
  if (frames.length > 0) {
    frames.forEach((element) => {
      frameIds.push(element.Id);
    });
  }
  return frameIds.join(",");
}

/**
 * 获取当前kpi系统登录人的所有角色
 * @param {*} userid 
 */
async function GetCurrentKpiUserRoles(userid)
{
    var paras={
        appId:apiConfig.hrAppid,
        userId:userid
    }
  return await GetByParas('c258d849-6866-4399-a544-04e61f84e28e',paras);   
}

//是否存在二维码
async function BindWx(userid){
  var paras={
    userId:userid
  }
  return await GetByParas('e2851d7c-5ed5-4071-a4f0-b360b88b0381',paras);  
}

//获取二维码链接
async function GetErWeiMaUrl(userid){
  var paras={
    userId:userid
  }
  return await GetByParas('	255df804-7c82-43ab-b0fc-36bf16f7d883	',paras);  
}

//解除绑定微信
async function UnBindWx(userid){
  var paras={
    userId:userid
  }
  return await GetByParas('	f3a897fe-ed01-42d9-82fa-014b459d5f61',paras);  
}
function getNowDateStr() {
  let yy = new Date().getFullYear();
  let mm = new Date().getMonth() + 1;
  let dd = new Date().getDate();
  let hh = new Date().getHours();
  let mf =
    new Date().getMinutes() < 10
      ? "0" + new Date().getMinutes()
      : new Date().getMinutes();
  let ss =
    new Date().getSeconds() < 10
      ? "0" + new Date().getSeconds()
      : new Date().getSeconds();
  var date = yy + "-" + mm + "-" + dd + " " + hh + ":" + mf + ":" + ss;
  return date;
}
export {
  GetSystemPowers,
  GetCurrentUserInfo,
  GetNewGuid,
  GetGuid,
  GetNoRead,
  GetChildrenFrameIdsByParentID,
  GetChildrenFrameIdsByParentIDLevelOne,
  GetDoneMessageList,
  SetDoneMessageRead,
  GetCurrentUserRoles,
  GetCurrentUserRole,
  GetCurrentKpiUserRoles,
  BindWx,
  GetErWeiMaUrl,
  UnBindWx,
  getNowDateStr
};
